"use client";

import {
  ArticleSection,
  ArticleSectionHeader,
} from "@/components/primitives/article";
import {
  ArticleCollapsibleGroup,
  ArticleCollapsibleItem,
} from "@/components/primitives/article-collapsible";
import { FAQ_SECTIONS } from "./faq-data";

export function FaqItems() {
  return (
    <div className="space-y-10">
      {FAQ_SECTIONS.map((section) => (
        <ArticleSection key={section.id}>
          <ArticleSectionHeader id={section.id}>
            {section.title}
          </ArticleSectionHeader>
          <ArticleCollapsibleGroup>
            {section.items.map((item) => (
              <ArticleCollapsibleItem
                key={item.question}
                question={item.question}
              >
                {item.answer}
              </ArticleCollapsibleItem>
            ))}
          </ArticleCollapsibleGroup>
        </ArticleSection>
      ))}
    </div>
  );
}
